export default __webpack_public_path__ + "static/media/logo.746ac231.png";